const European={
      slug:"europe",
      title: 'European Capitals',
      duration: '10 days',
      location: 'Paris, Rome, Amsterdam',
      difficulty: 'Easy',
      priceRange: '$$$ (Luxury)',
      bestTime: 'May-June, September-October',
      description: 'Experience the best of Europe by visiting three iconic capitals - Paris, Rome, and Amsterdam.',
      highlights: [
        'Eiffel Tower and Louvre Museum in Paris',
        'Colosseum and Vatican City in Rome',
        'Canal cruise in Amsterdam',
        'European cuisine and wine tasting',
        'Historic architecture and art'
      ],
      highlight360Views: [
  { label: "Eiffel Tower", place: "Eiffel Tower, Paris" },
  { label: "Colosseum", place: "Colosseum, Rome" },
  { label: "Vatican City", place: "Vatican City" },
  { label: "Amsterdam Canals", place: "Amsterdam Canals" },
  { label: "Louvre Museum", place: "Louvre Museum, Paris" }
],

      image: 'https://images.unsplash.com/photo-1585308772854-d6e58b04a767?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGV1cm9wfGVufDB8fDB8fHww',
  days: [
        {
        day: 1,
        title: 'Arrival in Paris',
        places:[
           'Charles de Gaulle Airport, Paris',
        'Central Paris',
        'Seine River, Paris',
        'Eiffel Tower, Paris',
        'Montmartre, Paris' 
        ],
        activities: [
            'Arrive at Charles de Gaulle Airport (CDG)',
            'Transfer to hotel in central Paris',
            'Evening Seine River cruise',
            'First view of Eiffel Tower',
            'Welcome dinner in Montmartre'
        ],
        accommodation: 'Paris hotel (4-star)',
        meals: 'Dinner included'
        },
        {
        day: 2,
        title: 'Paris City Highlights',
        places:[
             'Louvre Museum, Paris',
        'Notre-Dame Cathedral, Paris',
        'Latin Quarter, Paris',
        'Musée d’Orsay, Paris',
        'Eiffel Tower, Paris'
        ],
        activities: [
            'Early visit to Louvre Museum',
            'Notre-Dame Cathedral exterior visit',
            'Lunch in Latin Quarter',
            'Afternoon at Musée d\'Orsay',
            'Evening Eiffel Tower summit visit'
        ],
        accommodation: 'Paris hotel',
        meals: 'Breakfast included'
        },
        {
        day: 3,
        title: 'Paris - Versailles',
         places:[
             'Palace of Versailles',
        'Versailles Gardens',
        'Paris City Center'
        ],
        activities: [
            'Morning trip to Palace of Versailles',
            'Gardens and Hall of Mirrors tour',
            'Return to Paris for lunch',
            'Free afternoon for shopping',
            'Optional Moulin Rouge show'
        ],
        accommodation: 'Paris hotel',
        meals: 'Breakfast included'
        },
        {
        day: 4,
        title: 'Paris to Rome',
         places:[
             'Paris Airport',
        'Rome Fiumicino Airport',
        'Trevi Fountain, Rome',
        'Spanish Steps, Rome',
        'Trastevere, Rome'
        ],
        activities: [
            'Morning TGV train to airport',
            'Flight to Rome Fiumicino (FCO)',
            'Transfer to Rome hotel',
            'Evening walking tour: Trevi Fountain, Spanish Steps',
            'Dinner in Trastevere'
        ],
        accommodation: 'Rome hotel (4-star)',
        meals: 'Breakfast included'
        },
        {
        day: 5,
        title: 'Ancient Rome',
         places:[
              'Colosseum, Rome',
        'Roman Forum',
        'Capitoline Hill',
        'Pantheon, Rome'
        ],
        activities: [
            'Colosseum guided tour',
            'Roman Forum exploration',
            'Lunch near Capitoline Hill',
            'Afternoon at Pantheon',
            'Evening pizza making class'
        ],
        accommodation: 'Rome hotel',
        meals: 'Breakfast included'
        },
        {
        day: 6,
        title: 'Vatican City',
         places:[
            'Vatican Museums',
        'Sistine Chapel',
        'St. Peter’s Basilica',
        'Vatican City' 
        ],
        activities: [
            'Early Vatican Museums entry',
            'Sistine Chapel visit',
            'St. Peter\'s Basilica climb',
            'Lunch in Vatican area',
            'Free afternoon for shopping',
            'Optional pasta tasting tour'
        ],
        accommodation: 'Rome hotel',
        meals: 'Breakfast included'
        },
        {
        day: 7,
        title: 'Rome to Amsterdam',
         places:[
             'Rome Airport',
        'Amsterdam Schiphol Airport',
        'Anne Frank House, Amsterdam',
        'Amsterdam Canals'
        ],
        activities: [
            'Morning flight to Amsterdam Schiphol (AMS)',
            'Transfer to canal house hotel',
            'Afternoon Anne Frank House visit',
            'Evening canal cruise',
            'Indonesian rijsttafel dinner'
        ],
        accommodation: 'Amsterdam hotel (4-star)',
        meals: 'Breakfast included'
        },
        {
        day: 8,
        title: 'Amsterdam Exploration',
         places:[
            'Rijksmuseum, Amsterdam',
        'Van Gogh Museum',
        'Jordaan District',
        'Amsterdam City Center'
        ],
        activities: [
            'Rijksmuseum visit',
            'Van Gogh Museum',
            'Lunch in Jordaan district',
            'Bike tour of Amsterdam',
            'Evening in Red Light District'
        ],
        accommodation: 'Amsterdam hotel',
        meals: 'Breakfast included'
        },
        {
        day: 9,
        title: 'Dutch Countryside',
         places:[
            'Zaanse Schans',
        'Volendam Village',
        'Amsterdam'
        ],
        activities: [
            'Morning trip to Zaanse Schans windmills',
            'Cheese tasting and clog demonstration',
            'Lunch in Volendam fishing village',
            'Return to Amsterdam',
            'Farewell dinner'
        ],
        accommodation: 'Amsterdam hotel',
        meals: 'Breakfast and dinner included'
        },
        { 
        day: 10,
        title: 'Departure',
        places:[
            'Albert Cuyp Market, Amsterdam',
        'Amsterdam Schiphol Airport'
        ],
        activities: [
            'Last minute shopping at Albert Cuyp Market',
            'Optional Anne Frank House re-visit',
            'Transfer to Schiphol Airport',
            'Optional extension to Brussels or London'
        ],
        accommodation: 'N/A',
        meals: 'Breakfast included'
        }
    ],
    inclusions: [
        '9 nights accommodation (4-star hotels)',
        'Daily breakfast',
        'All inter-city flights and transfers',
        'High-speed train tickets where applicable',
        'Entrance to major attractions',
        'Local guides in each city'
    ],
    exclusions: [
        'International flights to/from Europe',
        'Travel insurance',
        'Most lunches and dinners',
        'Personal expenses',
        'Optional activities',
        'City taxes (paid locally)'
    ],
    tips: [
        'Book major attractions in advance',
        'Comfortable walking shoes essential',
        'Learn basic phrases in each language',
        'Keep passports secure',
        'Validate train tickets before boarding'
    ],
    budget: {
        flights: '$800-1200',
        accommodation: '$150-300/night',
        food: '$40-80/day',
        activities: '$50-100/day',
        transport: '$30-60/day',
        total: '$3000-5000 per person'
    }
    };
    export default European;